/*
 * 数据接口统一管理
 */
import axios from 'axios'
import { resolve } from 'path';
import { rejects } from 'assert';
import Bus from "./bus.js"


//测试开发、生产环境

// const baseUrlApi = 'https://test.api.smartfacade.com.cn'
const baseUrlApi = 'https://api.smartfacade.com.cn'
// 客户环境云平台接口地址
const configAPI  = 'https://manager-api.smartfacade.com.cn'

const openid = localStorage.getItem('openid');

const axiosGet = () => {

}
const assignParams = (data) => {
	let param = {
		openid: window.localStorage.getItem('openid'),
		web_token: window.localStorage.getItem('web_token')
	} 
	// console.log('assignParams param ', param)
	if (param.openid) {
		return Object.assign(data, param)
	} else {
		return data
	}
}
let flag = true;
const checkLoginStatus = (res) => {
	// console.log('checkLoginStatus res ', res)
	if (res.status === 200) {
		if (res.data.code === 401) {
			// console.log('401------------- ')
			// return

			localStorage.removeItem("openid");
			localStorage.removeItem("buildJson");
			localStorage.removeItem("web_token");
			localStorage.removeItem("user_info");
			localStorage.removeItem("user_id");
			localStorage.removeItem("level");
			localStorage.removeItem("loadObj");
			localStorage.removeItem("project_id");
			Bus.$emit('changeLoginStatus', false);

			// if(flag == true){
			// 	flag = false; //确保只弹窗一次				

				// Bus._data._this.$alert('登录失败，请在小程序中登录后再重新登录', '提示', {
				// 	confirmButtonText: '确定',
				// 	callback: action => {
				// 		let param = {
				// 			openid: window.localStorage.getItem('openid'),
				// 			web_token: window.localStorage.getItem('web_token')
				// 		}
				// 		api.logout(param).then(res => {
				// 			console.log('logout param ', param , ' res ', res)
				// 			if (res.data.code === 200) { 
				// 				localStorage.removeItem("openid");
				// 				localStorage.removeItem("buildJson");
				// 				localStorage.removeItem("web_token");
				// 				localStorage.removeItem("user_info");
				// 				localStorage.removeItem("user_id");
				// 				localStorage.removeItem("level");
				// 				localStorage.removeItem("loadObj");
				// 				localStorage.removeItem("project_id");
				// 				Bus.$emit('changeLoginStatus', false);
				// 				window.location.href = '/login';
				// 			}						
				// 		})					
				// 	}
				// });
			// }
		}
	}
}



const api = {
	baseUrlApi:function(){
		return baseUrlApi
	},
	getConfigApi: function() {
		return configAPI
	},
	/*
	 * 获取案例
	 */
	getCaseList: (data) => axios({
		method: 'get',
		url: `${baseUrlApi}/case/list?page=${data.page}&page_size=${data.page_size}&type=${data.type}`,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}),
	/**
	 * 获取案例详情
	 */
	getCaseDetail: (data) => axios({
		method: 'get',
		url: `${baseUrlApi}/case/${data.case_id}`,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}),
	/**
	 * 验证案例密码
	 */
	checkCasePassword: (data) => axios({
		method: 'POST',
		url: `${baseUrlApi}/case/checkPassword`,
		data: data,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}),
	/*
	 * 案例详情
	 */
	getCasePlanDetail: (res) => axios({
		method: 'get',
		url: `${baseUrlApi}/case/${res.case_id}/plan/${res.plan_id}`,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}),
	/*
	 * 风险点详情
	 */
	getCaseWarningDetail: (res) => axios({
		method: 'get',
		url: `${baseUrlApi}/case/${res.case_id}/warning/${res.warning_id}`,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}),
	getCaseArea: (res) => axios({
		method: 'get',
		url: `${baseUrlApi}/case/${res.case_id}/area/${res.building_id}`,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}),
	/*
	 * 审核通过/不通过
	 */
	getCaseAudit: (data) => axios({
		method: 'POST',
		url: `${baseUrlApi}/case/audit`,
		data: assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	 * 案例验收
	 */
	getCaseApproved: (data) => axios({
		method: 'POST',
		url: `${baseUrlApi}/case/approved`,
		data:assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	 * 获取我的项目列表
	 */
	getProjectList: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/project/list`,
		data:assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	 * 登录获取验证码
	 */
	getVerifyCode: (res) => axios({
		method: 'post',
		url: `${baseUrlApi}/user/phone/sendCode`,
		data: assignParams({
			phone: res
		}),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	 * 手机登录
	 */
	loginUser: (res) => axios({
		method: 'post',
		url: `${baseUrlApi}/user/phone/login`,
		data: assignParams(res),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	 * 获取项目成员列表
	 */
	getProjectMembers: (id) => axios({
		method: 'post',
		url: `${baseUrlApi}/personal/projectMembers`,
		data: assignParams({
			project_id: id,
			openid: window.localStorage.getItem('openid'),
			web_token: window.localStorage.getItem('web_token')
		}),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	 * 删除项目成员
	 */
	delMember: (id) => axios({
		method: 'post',
		url: `${baseUrlApi}/personal/deleteProjectMember`,
		data: assignParams({
			openid: openid,
			web_token: window.localStorage.getItem('web_token'),
			user_id: id
		}),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	 * 邀请添加项目成员
	 */
	bindMember: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/personal/addProjectMember`,
		data:assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	 * 获取合同列表
	 */
	getContracts: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/personal/contracts`,
		data:assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	 * 查看套餐内容
	 */
	getRepairDetail: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/require/item`,
		data:assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	 * 报检报修提交
	 */
	formSubmit: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/require/submit`,
		data:assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	 * 获取建筑信息
	 */
	building: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/require/building`,
		data:assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	 * 上传屏幕截图
	 */
	uploadScreenShot: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/project/uploadScreenShot`,
		data:assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	 * 获取屏幕截图
	 */
	getScreenShot: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/project/getScreenShot`,
		data:assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	 * 获取消息顶部数量
	 */
	getMsgList: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/notice/list`,
		data:assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	 * 获取日报数据
	 */
	getDatily: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/notice/daily`,
		data:assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	 * 获取月报数据
	 */
	getMonthly: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/notice/monthly`,
		data:assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	 * 任务详情
	 */
	getPlanDetail: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/project/planDetail`,
		data:assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	 * 计划审核
	 */
	planAudit: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/project/audit`,
		data:assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	 * 风险点详情
	 */
	warningDetail: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/project/warningDetail`,
		data:assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	 * 待审核验收
	 */
	approved: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/project/approved`,
		data:assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	 * 需协调事宜
	 */
	coordination: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/notice/coordination`,
		data:assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	 * 进度通知
	 */
	progress: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/notice/progress`,
		data:assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	 * 历史消息（进度通知）
	 */
	progressHistory: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/notice/progressHistory`,
		data:assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	 * 读取消息（进度通知）
	 */
	isRead: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/notice/isRead`,
		data:assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	 * 报检报修 条目
	 */
	getRepairItem: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/require/item`,
		data:assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	 * 报检报修 menu
	 */
	getRepairMenu: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/require/menu`,
		data: assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	 * 读取日报
	 */
	readDaily: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/notice/readDaily`,
		data:assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	 * 读取月报
	 */
	readMonthly: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/notice/readMonthly`,
		data:assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	* 我的项目获取模型信息
	*/
	myProjectGetBuilding: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/require/building`,
		data:assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	* 我的项目获取tabbar
	*/
	myGetTabbarVal: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/project/types`,
		data:assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	* 我的项目查看typelist
	*/
	myGetTypeList: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/project/typeList`,
		data:assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	* 案例获取模型信息
	*/
	caseProjectGetBuilding: (url) => axios({
		method: 'get',
		url: `${baseUrlApi}${url}`,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}),
	/*
	* 案例获取tabbar
	*/
	caseGetTabbarVal: (url) => axios({
		method: 'get',
		url: `${baseUrlApi}${url}`,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}),
	/*
	* 案例查看typelist
	*/
	caseGetTypeList: (url) => axios({
		method: 'get',
		url: `${baseUrlApi}${url}`,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}),
	/*
	* 新闻获取 web端新闻
	*/
	getNewsWeb: () => axios({
		method: 'post',
		url: `${baseUrlApi}/news/getConfig`,
		// url: 'https://test.api.smartfacade.com.cn/admin/news/getConfig',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},		
		data:assignParams({}),
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	/*
	* 获取案例列表
	*/
	getCaseListNew: () => axios({
		method: 'post',
		url: `${baseUrlApi}/case/getConfig`,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		data:assignParams({}),
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	//获取报检报修
	getReportConfig: () => axios({
		method: 'post',
		url: `${baseUrlApi}/require/getConfig`,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		data:assignParams({}),
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	loginByToken: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/user/loginByToken`,
		data:assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	logout: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/user/logout`,
		data: data,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}),
	getKey: () => axios({
		method: 'post',
		url: `${baseUrlApi}/key`,
		data: {},
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}),
	//获取城市 街道
	projects: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/project/group/projects`,
		data: assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	//获取分类
	getFilter: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/expert-admin/getFilter`,
		data: assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}),	
	//获取表格配置
	getTableConfig: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/expert-admin/getTableConfig`,
		data: assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),	
	// 获取筛选过后的建筑列表
	buildingFilter: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/expert-admin/buildingFilter`,
		data: assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),	
	// 获取建筑全景图
	getPanorama: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/expert-admin/getPanorama`,
		data: assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	// 获取建筑配置列表
	getBuildingConfig: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/expert-admin/getConfig`,
		data: assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	// 获取表格子项信息
	getTableItem: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/expert-admin/getTableItem`,
		data: assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	// 获取view_token
	viewToken: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/bimface/viewToken`,
		data: assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	// 获取全景
	getCameraList: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/project/street/panorama`,
		data: assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	// 获取楼层
	getAreaData: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/project/area`,
		data: assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	toContact: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/contact`,
		data: data,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	getNodeModel: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/nodeModel`,
		data: data,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	getCaseQrCode: (data) => axios({
		method: 'get',
		url: `${baseUrlApi}/wechat/createQrCode/case/${data.case_id}/${data.case_name}`,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'text'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	getProjectQrCode: (data) => axios({
		method: 'get',
		url: `${baseUrlApi}/wechat/createQrCode/project/0/0`,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'text'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),

	//获取token openID
	
	getTokenOpenId: (data) => axios({
		method: 'get',
		url: `${baseUrlApi}/wechat/openLogin?code=${data.code}&from=web`,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}),
	getNewHomeData: (data) => axios({
		method: 'get',
		url: `${baseUrlApi}/home/list`,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}),
	
	getWebNews: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/news/list`,
		data: data,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		checkLoginStatus(res)
		return res
	}),
	getWebNewsDetail: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/news/detail`,
		data: data,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}).then(res => {
		return res
	}),
	
	sendSysLog: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/cgi-bin/post.php`,
		data: assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'text'
	}),

	wechatConfig: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/wechat/config`,
		data: data,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}),
	hasStreet: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/project/hasStreet`,
		data: assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}),
	uploadPic: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/require/upload`,
		data: assignParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}),
	getCode: (data) => axios({
		method: 'post',
		url: `${baseUrlApi}/require/sendCode`,
		data: data,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		},
		responseType: 'json'
	}),
}

export default api





// WEBPACK FOOTER //
// ./src/utils/api.js